export const VOUCHER_ADD = "VOUCHER_ADD";
export const VOUCHER_UPDATED = "VOUCHER_UPDATED";
export const VOUCHER_REMOVE = "VOUCHER_REMOVE";
export const VOUCHER_ERROR = "VOUCHER_ERROR";
export const VOUCHER_FORMAT_CODE = "VOUCHER_FORMAT_CODE";
